/**
 * Centraliza o tratamento de erros: converte exceções (ou qualquer erro) em Failure.
 * Use em use cases: catch (e) { return handleError(e); }
 */

import {
  AppException,
  AuthException,
  ValidationException,
  NotFoundException,
  NetworkException,
} from './exceptions';
import { failure, type Failure } from './errors';

/** Mapeia qualquer exceção/erro para um Failure. */
export function handleError(error: unknown): Failure {
  if (error instanceof AuthException) {
    return failure(error.code, error.message, error.cause);
  }
  if (error instanceof ValidationException) {
    return failure(error.code, error.message, error.cause);
  }
  if (error instanceof NotFoundException) {
    return failure(error.code, error.message, error.cause);
  }
  if (error instanceof NetworkException) {
    return failure(error.code, error.message, error.cause);
  }
  if (error instanceof AppException) {
    return failure(error.code, error.message, error.cause);
  }
  if (error instanceof Error) {
    return failure('error/unknown', error.message, error);
  }
  return failure('error/unknown', String(error));
}
